<template>
    <div class="my-container page">
        <HomeFaq :faqs :hide-button="true" />
    </div>
</template>

<script setup>
const { locale, t } = useI18n()
const rc = useRuntimeConfig()
const faqs = ref((await $fetch(rc.public.api + '/api/faq')).data.list)
</script>